<!-- 竞猜列表 -->
<template>
<div class="guessing-item">
    <template v-if="showTime">
        <div class="down-time">
            <div class="tag"><span v-if="hour < 10">0</span>{{this.hour}}</div>
            <span>:</span>
            <div class="tag"><span v-if="minutes < 10 ">0</span>{{this.minutes}}</div>
            <span>:</span>
            <div class="tag"><span v-if="seconds <10">0</span>{{this.seconds}}</div>
            <div class="txt">截止时间</div>
        </div>
    </template>
    <template v-else>
        <div class="game-time" v-if="info.status == 0">
            <div class="time">{{info.endTime | timeFormat}}</div>
            <div class="txt">截止时间</div>
        </div>
        <div class="game-time" v-if="info.status == 1">
            <div class="txt">待揭晓</div>
        </div>
        <div class="game-end" v-if="info.status == 2">
            已结束
        </div>
    </template>
    
    <div class="game-team">
        <div class="team-item">
            <div class="tag" v-if="info.team1.win"><img :src="require('../assets/winer.png')" alt="" ></div>
            <div class="trem"><img :src="info.team1.imageUrl" alt=""></div>
            <div class="team-name">{{info.team1.name}}<span v-if="info.team1.staked">(已买)</span></div>
            <div class="pref">赔率{{info.team1.odds}}</div>
        </div>
        <div class="team-item tie">
            <div class="tag" v-if="info.tie.win"><img :src="require('../assets/tie.png')" alt="" ></div>
            <div class="against"><img :src="require('../assets/gold-vs.png')" alt=""></div>
            <div class="result" v-if="info.status == 1">
                ?:?
            </div>
            <div class="result" v-else-if="info.status == 2">
                {{info.team1.score}}:{{info.team2.score}}
            </div>
            <div style="margin-top:40px" v-else></div>
            <div class="team-name">和局<span v-if="info.tie.staked">(已买)</span></div>
            <div class="pref">赔率{{info.tie.odds}}</div>
        </div>
        <div class="team-item">
            <div class="tag" v-if="info.team2.win"><img :src="require('../assets/winer.png')" alt="" ></div>
            <div class="trem"><img :src="info.team2.imageUrl" alt=""></div>
            <div class="team-name">{{info.team2.name}}<span v-if="info.team2.staked">(已买)</span></div>
            <div class="pref">赔率{{info.team2.odds}}</div>
        </div>
    </div>

    <div class="sponser cont-row">
        <div class="flex-cont cont-row">
            <div class="sponser-name" v-if="info.sponsor">{{info.sponsor.title}}</div>
        </div>
        <div class="join-guessing" @click="guessingBetStatus= true"  v-if="info.status == 0">
            <img class="default" :src="require('../assets/forecast.png')" alt="">
            <img class="hover" :src="require('../assets/forecast-hover.png')" alt="">
        </div>
    </div>
    <GuessingBetGold :status.sync="guessingBetStatus" :info="info" @success="emitSuccess" />
</div>
</template>
<script>
import GuessingBetGold from '../dialog-gold/guessing-bet-gold.vue'
export default {
    name:'GuessingItemGold',
    components:{GuessingBetGold},
    props:['info'],
    data(){
        return {
            guessingBetStatus:false,
            showTime:false,
            lostTime:0,
            hour:0,
            minutes:0,
            seconds:0
        }
    },
    created(){
        let lastTime = new Date(this.info.gameStartTime).getTime() - Date.now();
        if( lastTime>0 && lastTime< 24*3600*1000){
            this.showTime = true;
            this.lostTime = Math.floor(lastTime/1000);
            this.downTime();
            
        }
    },
    methods:{
        downTime(){
            this.hour = Math.floor(this.lostTime / 3600);
            let load = this.lostTime % (3600);
            this.minutes = Math.floor( load /60 );
            this.seconds = load % 60;
            if(this.lostTime >0){
                setTimeout(()=>{
                    this.lostTime --;
                    this.downTime();
                },1000)
            }
        },
        emitSuccess(){
            this.$emit('success')
        }
    }
}
</script>
<style lang="less" scoped>
.guessing-item{
    position: relative;
    /* background: url(../assets/guessing-gold-bg.png) no-repeat center top; */border-radius: 8px; overflow: hidden; background-size: 100% 100%;
   /*  background-image: linear-gradient(0deg,  #FFE588 0% ,  #FFF2C9 40%,  #E9C666 60% , #E9C666 100%); */
    background-image: linear-gradient(-45deg,  #E9C666 0% ,  #E9C666 40%,  #FFF2C9 60% , #FFE588 100%);
    .down-time{
        margin: 15px; display: flex; align-items: center;
        color: #ff0000;
        .txt{font-size: 14px; line-height: 20px; margin-left: 10px;}
        > span{margin:0 2px;}
        >.tag{background: #ff0000; color: #fff; font-size: 14px; line-height: 24px; padding: 0 3px; border-radius: 4px;}
    }
    .game-time{
        margin: 15px; display: flex; align-items: center;
        .time{font-size:16px; line-height: 24px; color: #272727; font-weight: 600; margin-right: 10px;}
        .txt{font-size: 14px; line-height: 20px; color: #ff0000;}
    }
    .game-end{
        margin: 15px;font-size: 14px; line-height: 20px; color: #999;
    }
    .game-team{
        display: flex; align-items: flex-end; justify-content: space-around;text-align: center;
        .team-item{
            position: relative;
            .tag{position: absolute; left:50%; top: 20px; transform: translateX(-50%); display: flex;width:92px; height: 54px;
                img{width:100%; height: auto;}
            }
            &.tie{
                .tag{width: 86px; height: 51px;}
            }
            .trem{
                width:75px; height: 75px; border:2px solid #dadada; border-radius: 50%;  
                &>img{width:100%; height: 100%; object-fit: cover;border-radius: 50%; }
            }
            .team-name{font-size: 14px; line-height: 20px; color: #111; margin-top: 10px;
                span{font-size: 12px; color: #999;}
            }
            .pref{font-size: 12px; line-height: 18px; color: #B48802; margin-top: 3px;}
            .result{font-size: 14px; line-height: 20px; color: #ababab; background: #efefef; border-radius: 2px; margin-top: 5px;}
        }
    }
    .sponser{
        margin-top: 30px; padding: 10px 15px; background:url(../assets/gold-sponser-bg.png) no-repeat ; background-size: 100% 100%; min-height:60px; box-sizing: border-box;
        .sponser-name{font-size: 14px; line-height: 20px; color: #f0d9bb; opacity: 0.7;}
        .join-guessing{
            cursor: pointer;
            .default{display: block;}
            .hover{display: none;}
            &:hover{
                .default{display: none;}
                .hover{display: block;}
            }
        }
    }
    
}
@media screen and (max-width:768px){
    .guessing-item{
        .sponser{margin-top: 20px;}
    }
}
</style>